import {IStateProps, AccordionVariant} from './model';
import {NamedStyles, StyleHelper, useStyles} from '../../hooks/styles';
import {TouchableOpacity, View} from 'react-native';
import React from 'react';
import {stylePatterns} from '../../theme/patterns';
import {DeviceSize} from '../../theme/helpers';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import {images} from '../../../assets/icons';
import {Text} from '../text';

export default ({
  expanded,
  onPress,
  title,
  children,
  contentCustomStyle,
  wrapCustomStyle,
  variant,
  index,
}: IStateProps) => {
  const styles = useStyles((helper) => createStyles(helper, variant), [variant]);
  const isDesktop = useIsDesktop();
  const {Left: Arrow, ShapesCircle, ShapesCircleShadow} = images;

  const renderExtraByVariant = () => {
    if (variant === 'filled') {
      return (
        <>
          <View style={[styles.arrow, expanded && styles.arrowActive]}>
            <Arrow width={20} height={20} color={styles.arrow.color} />
          </View>
          {isDesktop ? (
            <View style={styles.shapeWrap}>
              {expanded ? <ShapesCircleShadow hideForVisuallyImpaired /> : <ShapesCircle hideForVisuallyImpaired />}
            </View>
          ) : null}
        </>
      );
    }

    return null;
  };

  return (
    <View style={[styles.wrap, wrapCustomStyle]}>
      <TouchableOpacity
        testID={`accordion-button-${index}-id`}
        style={styles.touchableHeaderZone}
        activeOpacity={isDesktop ? 1 : 0.5}
        onPress={onPress}>
        <View style={styles.header}>
          <Text testID={`accordion-title-${index}-id`} style={styles.headerText}>
            {title}
          </Text>
          {renderExtraByVariant()}
        </View>
      </TouchableOpacity>
      {expanded ? (
        <View style={[styles.content, contentCustomStyle]} testID={`accordion-body-${index}-id`}>
          {children}
        </View>
      ) : null}
    </View>
  );
};

const createStyles = ({theme, mediaOnly, isDesktop}: StyleHelper, variant: AccordionVariant): NamedStyles<any> => ({
  wrap:
    variant === 'filled'
      ? {
          overflow: 'hidden',
          borderRadius: 5,
          ...theme.accordion.itemFilledBoxShadow,
          marginBottom: isDesktop ? 30 : 20,
        }
      : {
          paddingHorizontal: 15,
          borderBottomWidth: 1,
          borderColor: theme.accordion.itemOutlinedBorderColor,
        },
  header:
    variant === 'filled'
      ? {
          position: 'relative',
          minHeight: 78,
          width: '100%',
          backgroundColor: theme.accordion.headerBgColor,
          paddingHorizontal: 15,
          paddingVertical: 10,
          ...stylePatterns.flexCenterVertical,
        }
      : {
          ...stylePatterns.flexCenterVertical,
          paddingVertical: isDesktop ? 23 : 18,
          minHeight: 78,
        },
  touchableHeaderZone: {
    zIndex: 1,
  },
  headerText:
    variant === 'filled'
      ? {
          ...mediaOnly(DeviceSize.desktop, theme.fonts.h3, theme.fonts.action),
          color: theme.accordion.headerTextColor,
          paddingRight: isDesktop ? 100 : 35,
        }
      : {
          ...mediaOnly(DeviceSize.desktop, theme.fonts.h4Light, theme.fonts.body),
        },
  content: {
    backgroundColor: theme.accordion.itemContentBgColor,
    ...mediaOnly(
      DeviceSize.desktop,
      {
        paddingHorizontal: 15,
        paddingVertical: 20,
      },
      {
        padding: 19,
      },
    ),
  },
  arrow: {
    position: 'absolute',
    top: 28,
    right: 15,
    transform: [{rotate: '-90deg'}],
    color: theme.accordion.headerTextColor,
  },
  arrowActive: {
    transform: [{rotate: '90deg'}],
  },
  shapeWrap: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: theme.accordion.headerTextColor,
  },
});
